import React from 'react';
import AuthorHero from '../components/author/AuthorHero';
import AuthorBio from '../components/author/AuthorBio';
import AuthorLinks from '../components/author/AuthorLinks';

const AuthorPage = () => (
  <main>
    <AuthorHero />
    <AuthorBio />
    <AuthorLinks />
  </main>
);

export default AuthorPage;